export default __webpack_public_path__ + "static/media/rocket_boy.419c143b.png";